(function () {
  'use strict';

  function initFzpPage(root) {
    if (!root || root.dataset.fzpInit === 'true') return;
    root.dataset.fzpInit = 'true';

    initReveal(root);
    initGallery(root);
    initAccordions(root);
    initWishlist(root);
    initBuyNow(root);
    initStickyCart(root);
    initScrollAtc(root);
    subscribeVariantChanges(root);
  }

  function initReveal(root) {
    const reveal = (el) => el.classList.add('in');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.querySelectorAll('[data-fzp-rv]').forEach(reveal);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px 80px 0px' }
    );

    root.querySelectorAll('[data-fzp-rv]').forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        reveal(el);
        return;
      }
      io.observe(el);
    });

    window.setTimeout(() => {
      root.querySelectorAll('[data-fzp-rv]:not(.in)').forEach(reveal);
    }, 2500);

    observeRelatedLoad(root, io, reveal);
  }

  function observeRelatedLoad(root, io, reveal) {
    const wrap = root.querySelector('.fzp-related-wrap');
    if (!wrap) return;

    const refreshReveal = () => {
      wrap.querySelectorAll('[data-fzp-rv]:not(.in)').forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          reveal(el);
        } else {
          io.observe(el);
        }
      });
    };

    const mo = new MutationObserver(() => {
      if (wrap.innerHTML.trim()) refreshReveal();
    });
    mo.observe(wrap, { childList: true, subtree: true });
  }

  function initGallery(root) {
    const mainImg = root.querySelector('.fzp-main-image');
    const thumbs = root.querySelectorAll('[data-fzp-thumb]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.dataset.src;
        if (!src) return;
        mainImg.style.opacity = '0';
        mainImg.style.transform = 'scale(0.97)';
        setTimeout(() => {
          mainImg.src = src;
          mainImg.style.opacity = '1';
          mainImg.style.transform = 'scale(1)';
        }, 180);
      });
    });
  }

  function initAccordions(root) {
    const items = root.querySelectorAll('[data-fzp-acc]');

    const measureAccordion = (item) => {
      const body = item.querySelector('.fzp-acc-body');
      const inner = body?.querySelector('.fzp-acc-body-inner');
      if (!body || !inner) return;
      body.style.maxHeight = item.classList.contains('open') ? `${inner.scrollHeight}px` : '0px';
    };

    const remeasureAll = () => items.forEach(measureAccordion);

    items.forEach((item) => {
      measureAccordion(item);
      item.querySelector('[data-fzp-acc-toggle]')?.addEventListener('click', () => {
        const wasOpen = item.classList.contains('open');
        items.forEach((i) => {
          i.classList.remove('open');
          i.querySelector('[data-fzp-acc-toggle]')?.setAttribute('aria-expanded', 'false');
          measureAccordion(i);
        });
        if (!wasOpen) {
          item.classList.add('open');
          item.querySelector('[data-fzp-acc-toggle]')?.setAttribute('aria-expanded', 'true');
          measureAccordion(item);
        }
      });
    });

    root.querySelectorAll('.fzp-acc-body-inner img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', remeasureAll, { once: true });
    });

    window.addEventListener('resize', remeasureAll, { passive: true });
  }

  function initBuyNow(root) {
    root.querySelectorAll('[data-fzp-buy-now]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        const productForm = btn.closest('product-form');
        const form = productForm?.querySelector('form');
        if (!form || btn.disabled) return;

        const submitButton = form.querySelector('[type="submit"]');
        if (submitButton?.disabled || submitButton?.getAttribute('aria-disabled') === 'true') return;

        btn.disabled = true;
        const config =
          typeof fetchConfig === 'function'
            ? fetchConfig('javascript')
            : { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } };
        delete config.headers['Content-Type'];
        config.body = new FormData(form);

        fetch(`${window.routes?.cart_add_url || '/cart/add'}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              productForm?.handleErrorMessage?.(response.description);
              return;
            }
            window.location.href = '/checkout';
          })
          .catch((error) => console.error(error))
          .finally(() => {
            btn.disabled = false;
          });
      });
    });
  }

  function initWishlist(root) {
    root.querySelectorAll('[data-fzp-wish]').forEach((btn) => {
      btn.addEventListener('click', () => btn.classList.toggle('on'));
    });
  }

  function initStickyCart(root) {
    const productInfo = root.closest('product-info');
    const sticky = productInfo?.querySelector('[data-fzp-sticky]');
    const ctaRow = root.querySelector('.fzp-cta-row');
    if (!sticky || !ctaRow) return;

    const setVisible = (visible) => {
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('fzp-has-sticky', visible);
    };

    const obs = new IntersectionObserver(
      ([entry]) => {
        setVisible(!entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '0px 0px -8px 0px' }
    );

    obs.observe(ctaRow);
    setVisible(false);

    root.querySelector('[data-fzp-sticky-atc]')?.addEventListener('click', () => {
      const mainAtc = root.querySelector('.fzp-btn-atc');
      if (!mainAtc || mainAtc.disabled) return;
      mainAtc.click();
    });
  }

  function initScrollAtc(root) {
    root.querySelector('[data-fzp-scroll-atc]')?.addEventListener('click', () => {
      root.querySelector('.fzp-cta-row')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => root.querySelector('.fzp-btn-atc')?.focus(), 400);
    });
  }

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.settings?.moneyFormat || '${{amount}}');
    }
    return (cents / 100).toFixed(2);
  }

  function subscribeVariantChanges(root) {
    const productInfo = root.closest('product-info');
    const stockEl = root.querySelector('[id^="FzpStock-"]');

    const updateFromVariant = (variant) => {
      if (!variant) return;
      const priceEl = root.querySelector('[data-fzp-price]');
      const stickyPrice = productInfo?.querySelector('[data-fzp-sticky-price]');
      const stickyImg = productInfo?.querySelector('.fzp-sticky-img-el');
      const stickyAtc = productInfo?.querySelector('[data-fzp-sticky-atc]');
      const stickyAtcLabel = productInfo?.querySelector('[data-fzp-sticky-atc-label]');
      const mainImg = root.querySelector('.fzp-main-image');

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stickyAtc) stickyAtc.disabled = !variant.available;
      if (stickyAtcLabel) {
        stickyAtcLabel.textContent = variant.available
          ? (window.variantStrings?.addToCart || 'Add to cart')
          : (window.variantStrings?.soldOut || 'Sold out');
      }
      if (stockEl) {
        stockEl.classList.toggle('out', !variant.available);
        stockEl.textContent = variant.available
          ? stockEl.dataset.inStock || 'In stock'
          : 'Sold out';
      }

      const buyNowBtn = root.querySelector('[data-fzp-buy-now]');
      if (buyNowBtn) buyNowBtn.hidden = !variant.available;

      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src;
        if (stickyImg) stickyImg.src = variant.featured_image.src;
        root.querySelectorAll('[data-fzp-thumb]').forEach((thumb) => {
          thumb.classList.toggle('active', Number(thumb.dataset.mediaId) === variant.featured_image.id);
        });
      }
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = productInfo?.dataset?.section;
        if (event?.data?.sectionId && sectionId && event.data.sectionId !== sectionId) return;
        updateFromVariant(event?.data?.variant);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-fzp-product-page]').forEach(initFzpPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('product-info:loaded', boot);
})();
